import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Logo from '../img/nebraska-txt.png'
import Cookies from 'js-cookie';
import { getB2CRedirectLogoutUrl } from "./../utils/url-constant";
import { useReportInventoryService } from '../services/ReportInventoryServices';
import { setDateInCST } from '../utils/dateUtils';

const Navbar = () => {
  const { instance, accounts } = useMsal();

  const history = useHistory();
  const [signedIn, setSignedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [logoutBuutonIsHovered, setlogoutBuutonIsHovered] = useState(false);
  const signedInUserType = sessionStorage.getItem('signedInUserType');

  const signedInUserData = sessionStorage.getItem('signedUpUserData');
  let loggedInUserName = signedInUserData ? JSON.parse(signedInUserData).name : null;
  const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
  const loggedInUserIPDetails = JSON.parse(sessionStorage.getItem('loginUserIPDetails') || '{}');
  const userType = sessionStorage.getItem('signedInUserType');
  let nonStateUserId = sessionStorage.getItem('signedInUserId');
  const ReportInventoryService = useReportInventoryService();

  const createAuditLogData = () => ({
    userId: loggedInUserDetails.userEmail || accounts?.[0]?.localAccountId || '',
    userSid: loggedInUserDetails.userId || accounts?.[0]?.localAccountId || '',
    accountTypeLkpcd: loggedInUserDetails?.accountTypeLkpcd || '',
    userIpv4Address: loggedInUserIPDetails?.ipAddress || '',
    userIpv6Address: loggedInUserIPDetails?.ipAddress || '',
    userMacAddress: loggedInUserIPDetails?.userMacAddress || null,
    userHostName: window?.location?.host || window?.location?.hostname || '',
    userRequestHeaderJson: null,
    eventLkpcd: 'LO',
    eventStatusLkpcd: 'S',
    pageName: 'admin_dashboard',
    componentApiName: null,
    componentApiAttributesJson: null,
    errorJson: null,
    mctReportInstanceSid: null,
    mctReportActivitySid: null,
    mctReportSubactivitySid: null,
    capturedScreenFileName: null,
    capturedScreenFileLocation: null,
    createdBy: loggedInUserDetails?.userEmail || accounts?.[0]?.localAccountId || '',
    createdDate: setDateInCST(new Date(), 'YYYY-MM-DDTHH:mm:ss'),
  });

  const msalLogOutHandle = async () => {

    await ReportInventoryService.createAuditLog(createAuditLogData());

    instance.logoutRedirect({
      account: accounts[0],
      postLogoutRedirectUri: "/sign-in",
    })

    // history.push(path);
    setSignedIn(false)

    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove('loginUserDetails');
    Cookies.remove('selectedProfile');
    Cookies.remove('selectedProfileLabel');
    Cookies.remove('msalToken');
    Cookies.remove('signedInUserType');

    // Remove cookies
    const removeCookie = (name: string) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    };

    // List of cookies to remove
    const cookiesToRemove = ['token', 'msalToken', 'signedInUserType'];

    cookiesToRemove.forEach(removeCookie);
  };

  const userLogoutHandle = async () => {
    await ReportInventoryService.createAuditLog(createAuditLogData());

    localStorage.clear();
    sessionStorage.clear();

    Cookies.remove('loginUserDetails');
    Cookies.remove('selectedProfile');
    Cookies.remove('selectedProfileLabel');
    Cookies.remove('msalToken');
    Cookies.remove('signedInUserType');

    // Remove cookies
    const removeCookie = (name: string) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    };

    // List of cookies to remove
    const cookiesToRemove = ['token', 'msalToken', 'signedInUserType', 'b2cUserDetails', 'b2cUserGroups'];

    cookiesToRemove.forEach(removeCookie);

    // Redirect to B2C sign-in URL
    const signOutUrl = getB2CRedirectLogoutUrl();
    if (signOutUrl) {
      console.log("Redirecting to B2C sign-out URL:", signOutUrl);
      if (userType === "HealthPlanUser" && nonStateUserId) {
        window.location.href = signOutUrl;
      }
    } else {
      console.error("Sign-in URL is undefined");
    }

    setTimeout(() => {
      history.push("/sign-in");
    }, 100);
  };

  const logoutButtonStyle = {
    width: '100px',
    border: logoutBuutonIsHovered ? '1px solid red' : '1px solid white',
    color: 'white',
    marginTop: '10px',
    fontWeight: 'bold',
    borderRadius: '3px',
    padding: '1.0rem',
    lineHeight: '1px',
  };

  const selectedProfileLabel = sessionStorage.getItem('selectedProfileLabel');

  return (
    <div>
      <div>
        <div className="header">
          <a className="logo" href={userType || (accounts?.[0]?.localAccountId) ? '/admin-dashboard' : undefined}>
            {/* <img src={Logo} alt="NEMCIS" className="w-24 sm:w-48"   /> */}
            <h2 title="Managed Care Program-Observability">NEMCIS</h2>
          </a>
          <div className="user-info">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              {accounts && accounts[0] && (
                <>
                  <span className='header-user-info-span'>
                    {/* Welcome:&nbsp;&nbsp;{loggedInUserDetails
                      ? `${loggedInUserDetails.userFirstName || ''} ${loggedInUserDetails.userMiddleName || ''} ${loggedInUserDetails.userLastName || ''}`
                      : accounts[0].name} */}
                    Welcome:&nbsp;&nbsp;{accounts[0].name || 'NEMCIS User'}
                  </span>
                  {selectedProfileLabel && (
                    <span className='header-user-info-span' style={{ marginTop: '1px' }}>
                      {selectedProfileLabel}
                    </span>
                  )}
                  <button
                    onClick={msalLogOutHandle}
                    onMouseEnter={() => setlogoutBuutonIsHovered(true)}
                    onMouseLeave={() => setlogoutBuutonIsHovered(false)}
                    style={logoutButtonStyle}
                  >
                    Logout
                  </button>

                </>
              )}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              {signedInUserType && (
                <>
                  <span className='header-user-info-span'>
                    {/* Welcome:&nbsp;&nbsp; {`${loggedInUserDetails?.userFirstName}` || 'Test User'} */}
                    Welcome:&nbsp;&nbsp;
                    {loggedInUserDetails?.userLastName || loggedInUserDetails?.userFirstName
                      ? `${loggedInUserDetails?.userLastName || ''}${loggedInUserDetails?.userFirstName && loggedInUserDetails?.userLastName ? ', ' : ''}${loggedInUserDetails?.userFirstName || ''}`
                      : 'Health User'}
                  </span>
                  {selectedProfileLabel && (
                    <span className='header-user-info-span' style={{ marginTop: '1px', marginBottom: '-2px' }}>
                      {selectedProfileLabel}
                    </span>
                  )}
                  <button
                    onClick={userLogoutHandle}
                    onMouseEnter={() => setlogoutBuutonIsHovered(true)}
                    onMouseLeave={() => setlogoutBuutonIsHovered(false)}
                    style={logoutButtonStyle}
                  >
                    Logout
                  </button>

                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="headerbottombar"></div>
    </div>
  );
};

export default Navbar;
